/* eslint-disable */
import _ from 'underscore';

declare global {
  interface Window {
    clarity?: (method: string, ...args: any[]) => void;
  }
}

export interface ClarityTags {
  [key: string]: string | number | boolean | object;
}

function initialize(projectId: string): void {
  try {
    (function (c: Window & typeof globalThis, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r) as HTMLScriptElement; t.async = true; t.src = `https://www.clarity.ms/tag/${i}`;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    }(window, document, 'clarity', 'script', projectId));
  } catch (all) { }
}

export function setClarityTag(tags: ClarityTags): void {
  if (window.clarity) {
    _.each(_.keys(tags), (key) => {
      const tagValue = tags[key];
      if (tagValue) {
        window.clarity('set', key, _.isString(tagValue) ? tagValue : JSON.stringify(tagValue));
      }
    });
  }
}

export function setupClarity(projectId: string, tags: ClarityTags = {}, userId?: string, sessionId?: string, pageId?: string): void {
  initialize(projectId);

  setClarityTag(tags);

  if (userId || sessionId || pageId) {
    window.clarity('identify', userId, sessionId, pageId);
  }
}